import pdfBike from '../../assets/guides/Gogeta Bike - Employer Guide.pdf';
import pdfNursery from '../../assets/guides/Gogeta Nursery - Employer Guide_2026.pdf';
import { isNotSSR } from '@utils';

export enum CONTACT_US_FORMS {
	BIKE = 'BIKE',
	NURSERY = 'NURSERY',
}

export const CONTACT_US_FORM_TITLE = 'Contact Us';
export const NURSERY_LOGIN_TITLE = 'Nursery login';
export const BIKE_LOGIN_TITLE = 'Bike login';

export interface IGroupItem {
	title: string;
	link: string;
	isItDownloadLink?: boolean;
	isContactUsItem?: boolean;
	keyword?: string;
	isExternalLink?: boolean;
}

export interface IFooterLinks {
	title: string;
	group?: IGroupItem[];
	link?: string;
	onClick?: () => void;
	footerLinkType?: IFooterLinkType;
}

export enum IFooterLinkType {
	CONTACT_US = 'CONTACT_US',
}

export const bikePortalsGroup: IGroupItem[] = [
	{
		title: 'Retailer',
		link: `${process.env.GATSBY_BIKE_WEBSITE}/portal/retailer_portal/auth/login/`,
		isExternalLink: true,
	},
	{
		title: 'Employer',
		link: `${process.env.GATSBY_BIKE_WEBSITE}/portal/auth/login/`,
		isExternalLink: true,
	},
	{
		title: 'Employee',
		link: `${process.env.GATSBY_BIKE_WEBSITE}/portal/employee_portal/auth/login/`,
		isExternalLink: true,
	},
];

export const nurseryPortalsGroup: IGroupItem[] = [
	{
		title: 'Sign in',
		link: `${process.env.GATSBY_NURSERY_WEBSITE}/portal/auth/login/`,
		isExternalLink: true,
	},
];

export const bikePortalsMenuGroup: IGroupItem[] = [
	{
		title: 'Employer',
		link: `${process.env.GATSBY_BIKE_WEBSITE}/portal/auth/login/`,
	},
	{
		title: 'Employee',
		link: `${process.env.GATSBY_BIKE_WEBSITE}/portal/employee_portal/auth/login/`,
	},
	{
		title: 'Retailer',
		link: `${process.env.GATSBY_BIKE_WEBSITE}/portal/retailer_portal/auth/login/`,
	},
];

export const nurseryPortalsMenuGroup: IGroupItem[] = [
	{
		title: 'Sign in',
		link: `${process.env.GATSBY_NURSERY_WEBSITE}/portal/auth/login/`,
		isExternalLink: true,
	},
];

const bikeGroup: IGroupItem[] = [
	{ title: 'I’m an employee', link: '/employee-cycling/' },
	{ title: 'I’m an employer', link: '/employer-cycling/' },
	{ title: 'I’m a retailer', link: '/provider-cycling/' },
];

const nurseryGroup: IGroupItem[] = [
	{ title: 'I’m an employee', link: '/employee-nursery/' },
	{ title: 'I’m an employer', link: '/employer-nursery/' },
	{ title: 'I’m a nursery', link: '/provider-nursery/' },
];

const techGroup: IGroupItem[] = [
	{ title: 'I’m an employee', link: '/employee-tech/' },
	{ title: 'I’m an employer', link: '/employer-tech/' },
];

const homeGroup: IGroupItem[] = [
	{ title: 'I’m an employee', link: '/employee-home/' },
	{ title: 'I’m an employer', link: '/employer-home/' },
];

const aboutUsGroup: IGroupItem[] = [
	{ title: 'About us', link: '/about-us/' },
	{ title: 'B Corp', link: '/b-corp/' },
	{ title: 'ISO 27001 certified', link: '/iso/' },
];

const contactUsGroup: IGroupItem[] = [
	{
		title: 'Gogeta Bike',
		link: '',
		isContactUsItem: true,
		keyword: CONTACT_US_FORMS.BIKE.toString(),
	},
	{
		title: 'Gogeta Nursery',
		link: '',
		isContactUsItem: true,
		keyword: CONTACT_US_FORMS.NURSERY.toString(),
	},
];

const headerTellMeMoreGroup: IGroupItem[] = [
	{ title: 'Blog', link: '/blog/' },
	{
		title: 'Employer guide to Gogeta Nursery',
		link: pdfNursery as string,
		isItDownloadLink: true,
	},
	{
		title: 'Employer guide to Gogeta Bike',
		link: pdfBike as string,
		isItDownloadLink: true,
	},
];

const footerTellMeMoreGroup: IGroupItem[] = [
	...headerTellMeMoreGroup,
	{
		title: 'Workplace nursery compliance',
		link: '/workplace-nursery-compliance/',
	},
	{
		title: 'Gogeta AI instructions',
		link: '/gogeta-ai-instructions/',
	},
];

// Footer Items - Desktop
export const firstLinksRowDesktop: IFooterLinks[] = [
	{
		title: 'Bike',
		link: '/gogeta-cycle-to-work-scheme/',
		group: bikeGroup,
	},
	{
		title: 'Nursery',
		link: '/workplace-nursery/',
		group: nurseryGroup,
	},
	{
		title: 'About Us',
		group: aboutUsGroup,
	},
	{
		title: CONTACT_US_FORM_TITLE,
		group: contactUsGroup,
	},
	{
		title: 'Linkedin',
		onClick: () => {
			isNotSSR && window.open('https://www.linkedin.com/company/gogetabenefits/home/');
		},
	},
	{
		title: 'Resources',
		group: footerTellMeMoreGroup,
	},
];

// Footer Items - Mobile
export const firstLinksRowMobile: IFooterLinks[] = [
	{
		title: 'Bike',
		link: '/gogeta-cycle-to-work-scheme/',
		group: bikeGroup,
	},
	{
		title: 'Nursery',
		link: '/workplace-nursery/',
		group: nurseryGroup,
	},
	{
		title: 'About Us',
		group: aboutUsGroup,
	},
	{
		title: 'Contact Us',
		group: contactUsGroup,
	},
	{
		title: 'Resources',
		group: footerTellMeMoreGroup,
	},
];

// Header
export const firstLinksRow: IFooterLinks[] = [
	{
		title: 'Bike',
		link: '/gogeta-cycle-to-work-scheme/',
		group: bikeGroup,
	},
	{
		title: 'Nursery',
		link: '/workplace-nursery/',
		group: nurseryGroup,
	},
	{
		title: 'About Us',
		group: aboutUsGroup,
	},
	{
		title: 'Contact Us',
		group: contactUsGroup,
	},
	{
		title: 'Resources',
		group: headerTellMeMoreGroup,
	},
	{
		title: BIKE_LOGIN_TITLE,
		group: bikePortalsGroup,
	},
	{
		title: NURSERY_LOGIN_TITLE,
		group: nurseryPortalsGroup,
	},
	{
		title: 'FAQs',
		link: '/faqs/',
	},
];
